<template>
    <div>
        <StrainDetail v-if="noticeType === 'strain'" />
        <BriefNoteDetail v-else-if="noticeType === 'brief-note'" />
        <IdxDetail v-else />
    </div>
</template>

<script setup>
import IdxDetail from './idx-detail.vue'
import StrainDetail from './strain-detail.vue'
import BriefNoteDetail from './brief-note-detail.vue';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const noticeType = ref(route.query.type || '')

onMounted(() => {
    noticeType.value = route.query.type || ''
})

</script>

<style lang='scss' scoped>
.news-detail-container {
    width: 100%;
    .breadcrumb {
        font-size: 14px;
        margin-bottom: 23px;
        .link {
            color: var(--srt-breadcrumb-text-color);
            &:hover {
                color: var(--srt-breadcrumb-hover-text-color);
            }
        }
        .separator {
            margin: 0 6px;
            color: var(--srt-color-gray);
        }
        .text {
            color: var(--srt-breadcrumb-disabled-text-color);
        }
    }
    .news-content {
        background: var(--srt-color-white);
        border-radius: 4px;
        padding: 50px;
        .header {
            font-size: 28px;
            color: var(--srt-main-text-color);
            line-height: 37px;
            text-align: center;
        }
        .date {
            font-size: 14px;
            color: var(--srt-color-gray);
            margin: 10px 0 30px 0;
        }
        .content {
            border-top: 1px solid #E0E2E4;
            padding-top: 30px;
        }
    }
}
</style>